// extracted by mini-css-extract-plugin
export var icon = "_42-3";
export var subtitle = "_42-2";
export var title = "_42-1";
export var value = "_42-0";